import { render, staticRenderFns } from "./PznSearch.vue?vue&type=template&id=41894cfd&"
import script from "./PznSearch.vue?vue&type=script&lang=js&"
export * from "./PznSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports